import { DomainEvent, ICommand, ProcessManagerContainer } from '@withlocals/cqrs.js/lib';
import { AuthenticationInfo } from '../../model/AuthenticationInfo';
import { InternalRefreshAuthCommand } from 'aggregates/authentication/queries';

export abstract class AccountCommand implements ICommand {
}

export class UpdateAccount extends AccountCommand {
  constructor(readonly data: any) {
    super();

  }
}

export class RefreshAccount extends AccountCommand {
}

export class AccountUpdated implements DomainEvent {
  constructor(readonly accountId: string) {
  }
}

export class AccountActions extends ProcessManagerContainer {
  constructor(protected authInfo: AuthenticationInfo) {
    super();
  }

  updateAccount(data: any) {
    return this.queue(new UpdateAccount(data));
  }

  refreshAccount() {
    return this.queue(new RefreshAccount());
  }

  refetchAccount() {
    return this.queue(new InternalRefreshAuthCommand());
  }
}
